import createVueComponent from '../createVueComponent';

const MoonStar = createVueComponent('MoonStarIcon', [
  ['path', { d: 'M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z', key: 'a7tn18' }],
  ['path', { d: 'M19 3v4', key: 'vgv24u' }],
  ['path', { d: 'M21 5h-4', key: '1wcg1f' }],
]);

export default MoonStar;
